import React, { useEffect, useState } from 'react';
import {
  Input,
  Button,
  Tabs,
  Table,
  Switch,
  Popconfirm,
  Modal,
  Select,
  Checkbox,
  DatePicker,
  Spin,
} from 'antd';
import Icon, { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { STATUS } from '../../../../redux/constants';
import styles from './playbooks.module.sass';
import { ReactComponent as PlaybookIcon } from '../../../../assets/icons/PlayCircle.svg';
import { ReactComponent as PlaybookPauseIcon } from '../../../../assets/icons/PauseCircle.svg';
import moment from 'moment-timezone';
import { ReactComponent as no_results } from '../../../../assets/icons/no_results.svg';
import {
  showNotification,
  simpleErrorNotification,
} from '../../../../shared-components/Notifications';

function Playbooks(props) {
  const {
    playbooksSettings,
    playbooksLogs,
    playbooksStatus,
    splunkSettings,
    userFilterProfiles,
  } = props;

  const [integrationData, setIntegrationData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedIntegration, setSelectedIntegration] = useState();
  const [selectedEditIntegration, setSelectedEditIntegration] = useState();
  const [selectedFilterProfile, setSelectedFilterProfile] = useState();
  const [selectedEditFilterProfile, setSelectedEditFilterProfile] = useState();
  const [allowRecurring, setAllowRecurring] = useState(false);
  const [allowOnce, setAllowOnce] = useState(false);
  const [selectedRate, setSelectedRate] = useState('');
  const [selectedTime, setSelectedTime] = useState('');
  const [selectedAlerts, setSelectedAlerts] = useState({});
  const [isMondaySet, setIsMondaySet] = useState(false);
  const [isTuesdaySet, setIsTuesdaySet] = useState(false);
  const [isWednesdaySet, setIsWednesdaySet] = useState(false);
  const [isThursdaySet, setIsThursdaySet] = useState(false);
  const [isFridaySet, setIsFridaySet] = useState(false);
  const [isSaturdaySet, setIsSaturdaySet] = useState(false);
  const [isSundaySet, setIsSundaySet] = useState(false);
  const [selectedOnceDate, setSelectedOnceDate] = useState();
  const [editPlaybookObject, setPlaybookObject] = useState({});
  const [nameFieldDisabled, setNameFieldDisabled] = useState(false);

  // Temporary solution, just to see which filters are available, requires reload the page sometimes

  const NoDataIcon = (props) => <Icon component={no_results} {...props} />;

  const usedFilterProfiles = playbooksSettings.map((playbook) => {
    return playbook?.filter_profile?.name;
  });

  const availebleFilterProfiles = userFilterProfiles?.filter(
    (item) => !usedFilterProfiles?.includes(item?.name),
  );

  function handleChange(e, name) {
    setIntegrationData({
      ...integrationData,
      [name]: e.target.value,
    });
  }

  function handleEditChange(e, name) {
    setPlaybookObject({
      ...editPlaybookObject,
      [name]: e.target.value,
    });
  }

  function handleRecurringChange() {
    setAllowRecurring((allowRecurring) => !allowRecurring);
    if (allowOnce === true) {
      setAllowOnce((allowOnce) => !allowOnce);
    }
  }

  function handleOnceChange() {
    setAllowOnce((allowOnce) => !allowOnce);

    if (allowRecurring === true) {
      setAllowRecurring((allowRecurring) => !allowRecurring);
    }
  }

  function handleNewPlaybookClick() {
    setAllowOnce(false);
    setAllowRecurring(false);
    setShowModal(true);
  }

  function handleEditClick(record) {
    setPlaybookObject(record);
    setSelectedAlerts(record?.alert);
    setSelectedEditFilterProfile(record?.filter_profile);

    if (
      record?.scheduler?.next_run &&
      record?.scheduler?.at === null &&
      record?.scheduler?.periodicity === null
    ) {
      setSelectedOnceDate(record?.scheduler?.next_run);
      setAllowOnce(true);
      setAllowRecurring(false);
      setSelectedEditIntegration(record?.integration);

      // setSelectedEditFilterProfile(record?.filter_profile);
    }

    if (record.scheduler.at !== null && record.scheduler.periodicity !== null) {
      setSelectedRate('daily');

      setSelectedTime(record?.scheduler?.at);
      if (record?.scheduler?.periodicity?.includes(0)) {
        setIsMondaySet(true);
      }
      if (record?.scheduler?.periodicity?.includes(1)) {
        setIsTuesdaySet(true);
      }
      if (record?.scheduler?.periodicity?.includes(2)) {
        setIsWednesdaySet(true);
      }
      if (record?.scheduler?.periodicity?.includes(3)) {
        setIsThursdaySet(true);
      }
      if (record?.scheduler?.periodicity?.includes(4)) {
        setIsFridaySet(true);
      }
      if (record?.scheduler?.periodicity?.includes(5)) {
        setIsSaturdaySet(true);
      }
      if (record?.scheduler?.periodicity?.includes(6)) {
        setIsSundaySet(true);
      }

      //setSelectedOnceDate(record?.scheduler?.next_run);
      setAllowRecurring(true);
      setAllowOnce(false);

      setSelectedEditIntegration(record?.integration);
      // setSelectedEditFilterProfile(record?.filter_profile);
    }

    if (record.scheduler.interval) {
      setSelectedRate('hourly');
      setSelectedTime(record?.scheduler?.interval);

      //setSelectedOnceDate(record?.scheduler?.next_run);
      setAllowRecurring(true);

      setAllowOnce(false);

      setSelectedEditIntegration(record?.integration);
      // setSelectedEditFilterProfile(record?.filter_profile);
    }

    //TODO recurring cases

    setShowEditModal(true);
  }

  function handleDeleteClick(record) {
    const playbookToDelete = record['uuid'];
    props.deletePlaybooks(playbookToDelete);
  }

  function handleSelectedIntegrationChange(integration) {
    setSelectedIntegration(integration);
  }

  function handleSelectedIntegrationEditChange(integration) {
    setSelectedEditIntegration(integration);
  }

  function handleSelectedFilterProfileChange(uuid, filter_profile) {
    const name = filter_profile.label;
    setSelectedFilterProfile({ uuid, name });
  }

  function handleSelectedFilterProfileEditChange(uuid, filter_profile) {
    const name = filter_profile.label;
    setSelectedEditFilterProfile({ uuid, name });
  }

  function handleSelectedRateChange(rate) {
    setSelectedRate(rate);
  }

  function handleSelectedTimeChange(time) {
    setSelectedTime(time);
  }

  /*function handleAlertChange(alert) {
    setSelectedAlerts((prevState) => ({ ...prevState, alert: alert }));
  }
*/

  function handleAlertChange(e, name) {
    if (name.includes('slack')) {
      setSelectedAlerts({
        ...selectedAlerts,
        [name.replace('slack', 'teams')]: e.target.checked,
        [name]: e.target.checked,
      });
    } else {
      setSelectedAlerts({
        ...selectedAlerts,
        [name]: e.target.checked,
      });
    }
  }

  function renderSundayButton() {
    const success = {
      backgroundColor: '#3C9AE8',
      color: 'white',
      position: 'absolute',
      top: '370px',
      left: '0px',
      border: '1px solid rgba(255, 255, 255, 0.3)',
      borderRadius: '4px',
    };
    const normal = {
      backgroundColor: '#213338',
      color: 'white',
      position: 'absolute',
      top: '370px',
      left: '0px',
      border: '1px solid rgba(255, 255, 255, 0.3)',
      borderRadius: '4px',
    };
    const style_to_use = isSundaySet ? success : normal;
    return (
      <Button
        onClick={() => setIsSundaySet(!isSundaySet)}
        style={style_to_use}
        disabled={!allowRecurring}
      >
        S
      </Button>
    );
  }

  const renderMondayButton = () => {
    const success = {
      backgroundColor: '#3C9AE8',
      color: 'white',
      position: 'absolute',
      top: '370px',
      left: '48px',
      border: '1px solid rgba(255, 255, 255, 0.3)',
      borderRadius: '4px',
    };
    const normal = {
      backgroundColor: '#213338',
      color: 'white',
      position: 'absolute',
      top: '370px',
      left: '48px',
      border: '1px solid rgba(255, 255, 255, 0.3)',
      borderRadius: '4px',
    };
    const style_to_use = isMondaySet ? success : normal;
    return (
      <Button
        onClick={() => setIsMondaySet(!isMondaySet)}
        style={style_to_use}
        disabled={!allowRecurring}
      >
        M
      </Button>
    );
  };

  function renderTuesdayButton() {
    const success = {
      backgroundColor: '#3C9AE8',
      color: 'white',
      position: 'absolute',
      top: '370px',
      left: '100px',
      border: '1px solid rgba(255, 255, 255, 0.3)',
      borderRadius: '4px',
    };
    const normal = {
      backgroundColor: '#213338',
      color: 'white',
      position: 'absolute',
      top: '370px',
      left: '100px',
      border: '1px solid rgba(255, 255, 255, 0.3)',
      borderRadius: '4px',
    };
    const style_to_use = isTuesdaySet ? success : normal;
    return (
      <Button
        onClick={() => setIsTuesdaySet(!isTuesdaySet)}
        style={style_to_use}
        disabled={!allowRecurring}
      >
        T
      </Button>
    );
  }

  function renderWednesdayButton() {
    const success = {
      backgroundColor: '#3C9AE8',
      color: 'white',
      position: 'absolute',
      top: '370px',
      left: '148px',
      border: '1px solid rgba(255, 255, 255, 0.3)',
      borderRadius: '4px',
    };
    const normal = {
      backgroundColor: '#213338',
      color: 'white',
      position: 'absolute',
      top: '370px',
      left: '148px',
      border: '1px solid rgba(255, 255, 255, 0.3)',
      borderRadius: '4px',
    };
    const style_to_use = isWednesdaySet ? success : normal;
    return (
      <Button
        onClick={() => setIsWednesdaySet(!isWednesdaySet)}
        style={style_to_use}
        disabled={!allowRecurring}
      >
        W
      </Button>
    );
  }

  function renderThursdayButton() {
    const success = {
      backgroundColor: '#3C9AE8',
      color: 'white',
      position: 'absolute',
      top: '370px',
      left: '202px',
      border: '1px solid rgba(255, 255, 255, 0.3)',
      borderRadius: '4px',
    };
    const normal = {
      backgroundColor: '#213338',
      color: 'white',
      position: 'absolute',
      top: '370px',
      left: '202px',
      border: '1px solid rgba(255, 255, 255, 0.3)',
      borderRadius: '4px',
    };
    const style_to_use = isThursdaySet ? success : normal;
    return (
      <Button
        onClick={() => setIsThursdaySet(!isThursdaySet)}
        style={style_to_use}
        disabled={!allowRecurring}
      >
        T
      </Button>
    );
  }

  function renderFridayButton() {
    const success = {
      backgroundColor: '#3C9AE8',
      color: 'white',
      position: 'absolute',
      top: '370px',
      left: '250px',
      border: '1px solid rgba(255, 255, 255, 0.3)',
      borderRadius: '4px',
    };
    const normal = {
      backgroundColor: '#213338',
      color: 'white',
      position: 'absolute',
      top: '370px',
      left: '250px',
      border: '1px solid rgba(255, 255, 255, 0.3)',
      borderRadius: '4px',
    };
    const style_to_use = isFridaySet ? success : normal;
    return (
      <Button
        onClick={() => setIsFridaySet(!isFridaySet)}
        style={style_to_use}
        disabled={!allowRecurring}
      >
        F
      </Button>
    );
  }

  function renderSaturdayButton() {
    const success = {
      backgroundColor: '#3C9AE8',
      color: 'white',
      position: 'absolute',
      top: '370px',
      left: '298px',
      border: '1px solid rgba(255, 255, 255, 0.3)',
      borderRadius: '4px',
    };
    const normal = {
      backgroundColor: '#213338',
      color: 'white',
      position: 'absolute',
      top: '370px',
      left: '298px',
      border: '1px solid rgba(255, 255, 255, 0.3)',
      borderRadius: '4px',
    };
    const style_to_use = isSaturdaySet ? success : normal;
    return (
      <Button
        onClick={() => setIsSaturdaySet(!isSaturdaySet)}
        style={style_to_use}
        disabled={!allowRecurring}
      >
        S
      </Button>
    );
  }

  function assembleDaysArray() {
    let dayArray = [];
    if (isMondaySet === true) {
      dayArray.push('0');
    }
    if (isTuesdaySet === true) {
      dayArray.push('1');
    }
    if (isWednesdaySet === true) {
      dayArray.push('2');
    }
    if (isThursdaySet === true) {
      dayArray.push('3');
    }
    if (isFridaySet === true) {
      dayArray.push('4');
    }
    if (isSaturdaySet === true) {
      dayArray.push('5');
    }
    if (isSundaySet === true) {
      dayArray.push('6');
    }
    return dayArray;
  }

  async function handleModalOk() {
    if (allowRecurring) {
      if (selectedRate === 'daily') {
        const daysArray = assembleDaysArray();

        await props.savePlaybooks({
          name: integrationData['name'],
          integration: {
            uuid: selectedIntegration,
            name: splunkSettings?.[0].name,
          },
          filter_profile: selectedFilterProfile?.uuid,
          scheduler: {
            periodicity: daysArray,
            at: selectedTime,
          },
          alert: selectedAlerts,
          active: true,
        });
      } else if (selectedRate === 'hourly') {
        await props.savePlaybooks({
          name: integrationData['name'],
          integration: {
            uuid: selectedIntegration,
            name: splunkSettings?.[0].name,
          },
          filter_profile: selectedFilterProfile?.uuid,
          scheduler: {
            interval: selectedTime,
          },
          alert: selectedAlerts,
          active: true,
        });
      }
    }

    if (allowOnce) {
      await props.savePlaybooks({
        name: integrationData['name'],
        integration: {
          uuid: selectedIntegration,
          name: splunkSettings?.[0].name,
        },
        filter_profile: selectedFilterProfile?.uuid,
        scheduler: {
          next_run: selectedOnceDate?.substring(
            0,
            selectedOnceDate?.length - 1,
          ),
        },
        alert: selectedAlerts,
        active: true,
      });
    }

    setShowModal(false);
    // setAllowOnce(false);
    // setAllowRecurring(false);
  }

  async function handleEditModalOk() {
    setSelectedAlerts({ playbook: selectedAlerts?.uuid });
    const selectedEditFilterProfileUUID =
      typeof selectedEditFilterProfile === 'string'
        ? selectedEditFilterProfile
        : selectedEditFilterProfile?.uuid;
    if (allowRecurring) {
      const daysArray = assembleDaysArray();
      //delete playbook from object
      const newAlerts = Object.assign({}, selectedAlerts);
      delete newAlerts?.playbook;

      if (selectedRate === 'daily') {
        props.updatePlaybooks({
          ...editPlaybookObject,
          name: editPlaybookObject?.name,
          integration: { uuid: selectedEditIntegration?.uuid },
          filter_profile: selectedEditFilterProfileUUID,
          scheduler: {
            periodicity: daysArray,
            at: selectedTime,
          },
          alert: newAlerts,
        });
      }

      if (selectedRate === 'hourly') {
        props.updatePlaybooks({
          ...editPlaybookObject,
          name: editPlaybookObject?.name,
          integration: { uuid: selectedEditIntegration?.uuid },
          filter_profile: selectedEditFilterProfileUUID,
          scheduler: {
            interval: selectedTime,
          },
          alert: newAlerts,
        });
      }
    }

    if (allowOnce) {
      //delete playbook from object
      const newAlerts = Object.assign({}, selectedAlerts);
      delete newAlerts?.playbook;

      props.updatePlaybooks({
        ...editPlaybookObject,
        name: editPlaybookObject?.name,
        integration: { uuid: selectedEditIntegration?.uuid },
        filter_profile: selectedEditFilterProfileUUID,
        scheduler: {
          next_run: selectedOnceDate?.substring(
            0,
            selectedOnceDate?.length - 1,
          ),
          at: null,
          periodicity: null,
        },
        alert: newAlerts,
      });
    }

    setShowEditModal(false);
    // setAllowOnce(false);
    // setAllowRecurring(false);
  }

  function handleDateChange(date) {
    setSelectedOnceDate(date);
  }

  function handleModalCancel() {
    setAllowRecurring(false);
    setShowModal(false);
    // setAllowOnce(false);
  }

  function handleEditModalCancel() {
    // setAllowOnce(false);
    // setAllowRecurring(false);
    setShowEditModal(false);
  }

  function selectTimeDropdown() {
    if (selectedRate === 'daily') {
      return (
        <>
          <p
            style={{
              position: 'absolute',
              top: '285px',
              left: '180px',
              width: '150px',
            }}
          >
            At
          </p>
          <Select
            defaultValue={selectedTime}
            disabled={!allowRecurring}
            placeholder="Select"
            style={{
              position: 'absolute',
              top: '310px',
              left: '170px',
              width: '120px',
            }}
            onChange={handleSelectedTimeChange}
          >
            <Select.Option value="00:00:00">12:00 AM</Select.Option>
            <Select.Option value="00:30:00">12:30 AM</Select.Option>
            <Select.Option value="01:00:00">1:00 AM</Select.Option>
            <Select.Option value="01:30:00">1:30 AM</Select.Option>
            <Select.Option value="02:00:00">2:00 AM</Select.Option>
            <Select.Option value="02:30:00">2:30 AM</Select.Option>
            <Select.Option value="03:00:00">3:00 AM</Select.Option>
            <Select.Option value="03:30:00">3:30 AM</Select.Option>
            <Select.Option value="04:00:00">4:00 AM</Select.Option>
            <Select.Option value="04:30:00">4:30 AM</Select.Option>
            <Select.Option value="05:00:00">5:00 AM</Select.Option>
            <Select.Option value="05:30:00">5:30 AM</Select.Option>
            <Select.Option value="06:00:00">6:00 AM</Select.Option>
            <Select.Option value="06:30:00">6:30 AM</Select.Option>
            <Select.Option value="07:00:00">7:00 AM</Select.Option>
            <Select.Option value="07:30:00">7:30 AM</Select.Option>
            <Select.Option value="08:00:00">8:00 AM</Select.Option>
            <Select.Option value="08:30:00">8:30 AM</Select.Option>
            <Select.Option value="09:00:00">9:00 AM</Select.Option>
            <Select.Option value="09:30:00">9:30 AM</Select.Option>
            <Select.Option value="10:00:00">10:00 AM</Select.Option>
            <Select.Option value="10:30:00">10:30 AM</Select.Option>
            <Select.Option value="11:00:00">11:00 AM</Select.Option>
            <Select.Option value="11:30:00">11:30 AM</Select.Option>
            <Select.Option value="12:00:00">12:00 PM</Select.Option>
            <Select.Option value="12:30:00">12:30 PM</Select.Option>
            <Select.Option value="13:00:00">1:00 PM</Select.Option>
            <Select.Option value="13:30:00">1:30 PM</Select.Option>
            <Select.Option value="14:00:00">2:00 PM</Select.Option>
            <Select.Option value="14:30:00">2:30 PM</Select.Option>
            <Select.Option value="15:00:00">3:00 PM</Select.Option>
            <Select.Option value="15:30:00">3:30 PM</Select.Option>
            <Select.Option value="16:00:00">4:00 PM</Select.Option>
            <Select.Option value="16:30:00">4:30 PM</Select.Option>
            <Select.Option value="17:00:00">5:00 PM</Select.Option>
            <Select.Option value="17:30:00">5:30 PM</Select.Option>
            <Select.Option value="18:00:00">6:00 PM</Select.Option>
            <Select.Option value="18:30:00">6:30 PM</Select.Option>
            <Select.Option value="19:00:00">7:00 PM</Select.Option>
            <Select.Option value="19:30:00">7:30 PM</Select.Option>
            <Select.Option value="20:00:00">8:00 PM</Select.Option>
            <Select.Option value="20:30:00">8:30 AM</Select.Option>
            <Select.Option value="21:00:00">9:00 PM</Select.Option>
            <Select.Option value="21:30:00">9:30 PM</Select.Option>
            <Select.Option value="22:00:00">10:00 PM</Select.Option>
            <Select.Option value="22:30:00">10:30 PM</Select.Option>
            <Select.Option value="23:00:00">11:00 PM</Select.Option>
            <Select.Option value="23:30:00">11:30 PM</Select.Option>
          </Select>
          {renderSundayButton()}
          {renderMondayButton()}
          {renderTuesdayButton()}
          {renderWednesdayButton()}
          {renderThursdayButton()}
          {renderFridayButton()}
          {renderSaturdayButton()}
        </>
      );
    } else if (selectedRate === 'hourly') {
      return (
        <>
          <p
            style={{
              position: 'absolute',
              top: '285px',
              left: '180px',
              width: '150px',
            }}
          >
            Every
          </p>
          <Select
            defaultValue={selectedTime}
            disabled={!allowRecurring}
            placeholder="Select"
            style={{
              position: 'absolute',
              top: '310px',
              left: '170px',
              width: '120px',
            }}
            onChange={handleSelectedTimeChange}
          >
            <Select.Option value="00:30:00">30 minutes</Select.Option>
            <Select.Option value="01:00:00">1 hour</Select.Option>
            <Select.Option value="02:00:00">2 hours</Select.Option>
            <Select.Option value="03:00:00">3 hours</Select.Option>
            <Select.Option value="04:00:00">4 hours</Select.Option>
            <Select.Option value="05:00:00">5 hours</Select.Option>
            <Select.Option value="06:00:00">6 hours</Select.Option>
            <Select.Option value="07:00:00">7 hours</Select.Option>
            <Select.Option value="08:00:00">8 hours</Select.Option>
            <Select.Option value="09:00:00">9 hours</Select.Option>
            <Select.Option value="10:00:00">10 hours</Select.Option>
            <Select.Option value="11:00:00">11 hours</Select.Option>
            <Select.Option value="12:00:00">12 hours</Select.Option>
            <Select.Option value="13:00:00">13 hours</Select.Option>
            <Select.Option value="14:00:00">14 hours</Select.Option>
            <Select.Option value="15:00:00">15 hours</Select.Option>
            <Select.Option value="16:00:00">16 hours</Select.Option>
            <Select.Option value="17:00:00">17 hours</Select.Option>
            <Select.Option value="18:00:00">18 hours</Select.Option>
            <Select.Option value="19:00:00">19 hours</Select.Option>
            <Select.Option value="20:00:00">20 hours</Select.Option>
            <Select.Option value="21:00:00">21 hours</Select.Option>
            <Select.Option value="22:00:00">22 hours</Select.Option>
            <Select.Option value="23:00:00">23 hours</Select.Option>
          </Select>
        </>
      );
    }
  }

  function handleAlertsSwitchChange(record) {
    const alertState = record?.alert?.active;
    const filterProfile =
      record?.filter_profile?.uuid || record?.filter_profile;

    if (record?.alert) {
      //removing playbooks from alert object
      const {
        alert: { playbook, ...alert },
      } = record;

      props.updatePlaybooks({
        ...record,
        alert: { ...alert, active: !alertState },
        filter_profile: filterProfile,
      });
    } else {
      showNotification(
        simpleErrorNotification({
          statusCode: 400,
          message: 'Set up alerts first by editing the scheduler.',
        }),
      );
    }
  }

  function handlePlayButtonClick(record) {
    const filterProfile = record?.filter_profile?.uuid;

    //removing playbooks from alert object
    const {
      alert: { playbook, ...alert },
    } = record;

    props.updatePlaybooks({
      ...record,
      alert: { ...alert },
      active: !record.active,
      filter_profile: filterProfile,
    });
  }

  function handlePlayOnceButtonClick(record) {
    props.runPlaybooks(record.uuid);
  }

  useEffect(() => {
    document.title = 'Playbook - Silent Push';
    props.loadSplunk();
    props.loadPlaybooks();
    props.loadPlaybooksLogs();
    props.loadUser();
    props.loadFilterProfiles();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (playbooksStatus === STATUS.LOADED) {
      ///playbooksSettings.map((playbook) =>
      //   props.loadPlaybooksLogs(playbook?.uuid),
      //);
      //setUserData(props.user);
    }
  }, [playbooksStatus]);

  useEffect(() => {
    //if (status === STATUS.LOADED) {
    //setUserData(props.user);
    //}
  }, [allowRecurring, allowOnce]);

  const columns = [
    {
      title: 'Status',
      dataIndex: 'active',
      key: 'active',
      render: (text, record, index) => {
        return (
          <div className={styles['play-button']}>
            {record.active === true ? (
              <PlaybookPauseIcon
                onClick={() => handlePlayButtonClick(record)}
              />
            ) : (
              <PlaybookIcon onClick={() => handlePlayButtonClick(record)} />
            )}
          </div>
        );
      },
    },
    {
      title: '',
      dataIndex: '',
      key: '',
      render: (text, record, index) => {
        return (
          <Button onClick={() => handlePlayOnceButtonClick(record)}>
            Run once
          </Button>
        );
      },
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },

    {
      title: 'Products',
      dataIndex: ['integration', 'name'],
      key: 'integration.name',
    },
    {
      title: 'Scheduled',
      dataIndex: ['scheduler', 'next_run'],
      key: 'scheduler.next_run',
      render: (text, record, index) => {
        return (
          <span>
            {record?.scheduler?.next_run
              ? moment(record?.scheduler?.next_run).format('YYYY-MM-DD HH:mm')
              : ''}
          </span>
        );
      },
    },
    {
      title: 'Last sync',
      dataIndex: ['log', 'date'],
      key: 'log.date',
    },
    {
      title: 'Alerts',
      dataIndex: 'alerts',
      key: 'alerts',
      render: (text, record, index) => {
        return (
          <div>
            <Switch
              disabled={record?.alert ? false : true}
              checked={record?.alert?.active}
              onChange={() => handleAlertsSwitchChange(record)}
            />
          </div>
        );
      },
    },
    {
      title: '',
      dataIndex: 'alerts2',
      key: 'alerts2',
      render: (text, record, index) => {
        return (
          <div className={styles['action-buttons']}>
            {/* <EyeOutlined onClick={() => handleViewClick(record)} /> */}
            <EditOutlined onClick={() => handleEditClick(record)} />
            <Popconfirm
              title="Are you sure?"
              onConfirm={() => handleDeleteClick(record)}
            >
              <DeleteOutlined />
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const logColumns = [
    {
      title: 'Name',
      dataIndex: ['playbook', 'name'],
      key: 'playbook.uuid',
    },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
    },

    {
      title: 'Product',
      dataIndex: 'message',
      key: 'message',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: 'title',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Info',
      dataIndex: 'info',
      key: 'info',
    },
  ];

  //const tableDataSource = [...playbooksSettings, playbooksLogs];

  function createDataTable() {
    //const playbookFirstLog = playbooksLogs;
    const newPlaybookData = playbooksSettings?.map((playbook) => ({
      ...playbook,
      log: playbooksLogs?.filter(
        (x) => x.status === 'succeeded' && x.playbook.uuid === playbook.uuid,
      )[0],
    }));

    return newPlaybookData;
    //const index = playbooksLogs.findIndex((p) => p.uuid === APIAccessUUID);
  }

  function renderPlayBookList() {
    return (
      <Table
        locale={{
          emptyText: (
            <span>
              <NoDataIcon style={{ fontSize: 32 }} />
              <p
                style={{
                  color: 'rgba(255, 255, 255, 0.95)',
                  fontFamily: 'TT Hoves',
                  fontWeight: 600,
                  fontSize: '16px',
                  lineHeight: '19px',
                  fontStyle: 'normal',
                }}
              >
                Scheduler list is empty
              </p>
              <p
                style={{
                  color: 'rgba(255, 255, 255, 0.95)',
                }}
              >
                Click on the{' '}
                <p
                  style={{
                    color: '#3C9AE8',
                    display: 'inline',
                  }}
                  onClick={handleNewPlaybookClick}
                >
                  Add New
                </p>{' '}
                button to add a new Scheduler.{' '}
              </p>
            </span>
          ),
        }}
        columns={columns}
        dataSource={createDataTable()}
        pagination={false}
      />
    );
  }

  function renderPlayBookLogs() {
    return (
      <Table
        locale={{
          emptyText: (
            <span>
              <NoDataIcon style={{ fontSize: 32 }} />
              <p
                style={{
                  color: 'rgba(255, 255, 255, 0.95)',
                  fontFamily: 'TT Hoves',
                  fontWeight: 600,
                  fontSize: '16px',
                  lineHeight: '19px',
                  fontStyle: 'normal',
                }}
              >
                Scheduler logs are empty
              </p>
              <p
                style={{
                  color: 'rgba(255, 255, 255, 0.95)',
                }}
              >
                None of your schedulers ran. Click on Play once in Scheduler
                list to manually start syncing.
              </p>
            </span>
          ),
        }}
        columns={logColumns}
        dataSource={playbooksLogs}
        pagination={false}
      />
    );
  }

  const isPlaybooksLoading = playbooksStatus === STATUS.LOADING;

  return (
    <div className={styles.container}>
      {isPlaybooksLoading && <Spin style={{ margin: 40 }} />}
      {!isPlaybooksLoading && (
        <>
          <Modal
            width={624}
            visible={showModal}
            onCancel={handleModalCancel}
            onOk={handleModalOk}
          >
            <div
              style={{
                position: 'relative',
                height: '40px',
                width: '100%',
                borderBottom: '1px solid rgba(255,255,255,0.2)',
              }}
            >
              <p
                style={{
                  fontFamily: 'TT Hoves',
                  fontStyle: 'normal',
                  fontWeight: 'bold',
                  fontSize: '16px',
                  lineHeight: '19px',
                  color: '#ffffff',
                }}
              >
                Create New Scheduler
              </p>
            </div>
            <div
              style={{
                position: 'relative',
                height: '700px',
              }}
            >
              <div style={{ position: 'relative' }}>
                <p
                  style={{
                    position: 'absolute',
                    top: '25px',
                    left: '10px',
                    fontFamily: 'TT Hoves',
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    fontSize: '14px',
                    lineHeight: '16px',
                  }}
                >
                  Scheduler Name
                </p>
                <Input
                  style={{
                    position: 'absolute',
                    top: '50px',
                    left: '0px',
                    width: '580px',
                  }}
                  disabled={nameFieldDisabled}
                  placeholder={integrationData['name'] ?? 'Name'}
                  value={integrationData['name']}
                  onChange={(e) => handleChange(e, 'name')}
                ></Input>
              </div>
              <div style={{ position: 'relative' }}>
                <p style={{ position: 'absolute', top: '105px', left: '10px' }}>
                  Select Products
                </p>
                <Select
                  placeholder="Select"
                  style={{
                    position: 'absolute',
                    top: '130px',
                    left: '0px',
                    width: '150px',
                  }}
                  options={splunkSettings.map((item) => ({
                    value: item.uuid,
                    label: item.name,
                  }))}
                  onChange={handleSelectedIntegrationChange}
                ></Select>
              </div>
              <div style={{ position: 'relative' }}>
                <p
                  style={{ position: 'absolute', top: '105px', left: '210px' }}
                >
                  Import Filter Profiles
                </p>
                <Select
                  placeholder="Select"
                  style={{
                    position: 'absolute',
                    top: '130px',
                    left: '200px',
                    width: '150px',
                  }}
                  options={availebleFilterProfiles?.map((item) => ({
                    value: item.uuid,
                    label: item.name,
                  }))}
                  onChange={handleSelectedFilterProfileChange}
                ></Select>
              </div>
              <div style={{ position: 'relative' }}>
                <p
                  style={{
                    position: 'absolute',
                    top: '200px',
                    left: '0px',
                    fontWeight: 600,
                  }}
                >
                  Schedule a Sync
                </p>

                <p style={{ position: 'absolute', top: '240px', left: '0px' }}>
                  Recurring
                </p>
                <Switch
                  checked={allowRecurring}
                  style={{ position: 'absolute', top: '240px', left: '70px' }}
                  onChange={() => handleRecurringChange()}
                />
                <p
                  style={{ position: 'absolute', top: '240px', left: '350px' }}
                >
                  Once
                </p>
                <Switch
                  checked={allowOnce}
                  style={{ position: 'absolute', top: '240px', left: '390px' }}
                  onChange={() => handleOnceChange()}
                />
                <p
                  style={{
                    position: 'absolute',
                    top: '285px',
                    left: '10px',
                    width: '150px',
                  }}
                >
                  Rate
                </p>
                <Select
                  disabled={!allowRecurring}
                  placeholder="Select"
                  style={{
                    position: 'absolute',
                    top: '310px',
                    left: '0px',
                    width: '150px',
                  }}
                  onChange={handleSelectedRateChange}
                >
                  <Select.Option value="daily">Daily</Select.Option>
                  <Select.Option value="hourly">Hourly</Select.Option>
                </Select>
                {allowRecurring && selectTimeDropdown()}
                <p
                  style={{
                    position: 'absolute',
                    top: '285px',
                    left: '360px',
                    width: '100px',
                  }}
                >
                  Date
                </p>
                <DatePicker
                  showTime
                  format="YYYY-MM-DD HH:mm"
                  disabled={!allowOnce}
                  style={{
                    position: 'absolute',
                    top: '310px',
                    left: '350px',
                    width: '150px',
                  }}
                  className="sidebar_input"
                  //value={selectedDay}
                  onChange={(dateM) => handleDateChange(dateM.toISOString())}
                  getPopupContainer={(trigger) => trigger.parentNode}
                />
              </div>
              <div style={{ position: 'relative' }}>
                <p
                  style={{
                    position: 'absolute',
                    top: '440px',
                    left: '0px',
                    fontWeight: 600,
                  }}
                >
                  Alerts
                </p>
                <p
                  style={{ position: 'absolute', top: '440px', left: '380px' }}
                >
                  Chat
                </p>
                <p
                  style={{ position: 'absolute', top: '440px', left: '450px' }}
                >
                  In App
                </p>

                <p
                  style={{ position: 'absolute', top: '440px', left: '520px' }}
                >
                  E-mail
                </p>
                {/*<p style={{ position: 'absolute', top: '480px', left: '0px' }}>
                  All
                </p>
                <Checkbox
                  onChange={(e) => handleAlertChange(e, 'all_app')}
                  style={{ position: 'absolute', top: '480px', left: '450px' }}
                ></Checkbox>
                <Checkbox
                  onChange={(e) => handleAlertChange(e, 'all_email')}
                  style={{ position: 'absolute', top: '480px', left: '520px' }}
                ></Checkbox>*/}
                <p style={{ position: 'absolute', top: '520px', left: '0px' }}>
                  List has been updated
                </p>
                <Checkbox
                  onChange={(e) => handleAlertChange(e, 'slack_list_updated')}
                  style={{ position: 'absolute', top: '520px', left: '380px' }}
                ></Checkbox>
                <Checkbox
                  onChange={(e) => handleAlertChange(e, 'app_list_updated')}
                  style={{ position: 'absolute', top: '520px', left: '450px' }}
                ></Checkbox>
                <Checkbox
                  onChange={(e) => handleAlertChange(e, 'email_list_updated')}
                  style={{ position: 'absolute', top: '520px', left: '520px' }}
                ></Checkbox>
                <p style={{ position: 'absolute', top: '560px', left: '0px' }}>
                  Successful upload to product
                </p>
                <Checkbox
                  onChange={(e) =>
                    handleAlertChange(e, 'slack_successful_upload')
                  }
                  style={{ position: 'absolute', top: '560px', left: '380px' }}
                ></Checkbox>
                <Checkbox
                  onChange={(e) =>
                    handleAlertChange(e, 'app_successful_upload')
                  }
                  style={{ position: 'absolute', top: '560px', left: '450px' }}
                ></Checkbox>
                <Checkbox
                  onChange={(e) =>
                    handleAlertChange(e, 'email_successful_upload')
                  }
                  style={{ position: 'absolute', top: '560px', left: '520px' }}
                ></Checkbox>
                <p style={{ position: 'absolute', top: '600px', left: '0px' }}>
                  Unsuccessful upload to product
                </p>
                <Checkbox
                  onChange={(e) =>
                    handleAlertChange(e, 'slack_unsuccessful_upload')
                  }
                  style={{ position: 'absolute', top: '600px', left: '380px' }}
                ></Checkbox>
                <Checkbox
                  onChange={(e) =>
                    handleAlertChange(e, 'app_unsuccessful_upload')
                  }
                  style={{ position: 'absolute', top: '600px', left: '450px' }}
                ></Checkbox>
                <Checkbox
                  onChange={(e) =>
                    handleAlertChange(e, 'email_unsuccessful_upload')
                  }
                  style={{ position: 'absolute', top: '600px', left: '520px' }}
                ></Checkbox>
                <p style={{ position: 'absolute', top: '640px', left: '0px' }}>
                  Settings have been changed
                </p>
                <Checkbox
                  onChange={(e) =>
                    handleAlertChange(e, 'slack_settings_changed')
                  }
                  style={{ position: 'absolute', top: '640px', left: '380px' }}
                ></Checkbox>
                <Checkbox
                  onChange={(e) => handleAlertChange(e, 'app_settings_changed')}
                  style={{ position: 'absolute', top: '640px', left: '450px' }}
                ></Checkbox>
                <Checkbox
                  onChange={(e) =>
                    handleAlertChange(e, 'email_settings_changed')
                  }
                  style={{ position: 'absolute', top: '640px', left: '520px' }}
                ></Checkbox>
                <p style={{ position: 'absolute', top: '680px', left: '0px' }}>
                  Assigned filter profile has been changed
                </p>
                <Checkbox
                  onChange={(e) =>
                    handleAlertChange(e, 'slack_profile_changed')
                  }
                  style={{ position: 'absolute', top: '680px', left: '380px' }}
                ></Checkbox>
                <Checkbox
                  onChange={(e) => handleAlertChange(e, 'app_profile_changed')}
                  style={{ position: 'absolute', top: '680px', left: '450px' }}
                ></Checkbox>
                <Checkbox
                  onChange={(e) =>
                    handleAlertChange(e, 'email_profile_changed')
                  }
                  style={{ position: 'absolute', top: '680px', left: '520px' }}
                ></Checkbox>
              </div>
            </div>
          </Modal>

          <Modal
            width={624}
            visible={showEditModal}
            onCancel={handleEditModalCancel}
            onOk={handleEditModalOk}
          >
            <div
              style={{
                position: 'relative',
                height: '40px',
                width: '100%',
                borderBottom: '1px solid rgba(255,255,255,0.2)',
              }}
            >
              <p
                style={{
                  fontFamily: 'TT Hoves',
                  fontStyle: 'normal',
                  fontWeight: 'bold',
                  fontSize: '16px',
                  lineHeight: '19px',
                  color: '#ffffff',
                }}
              >
                Edit Scheduler
              </p>
            </div>
            <div
              style={{
                position: 'relative',
                height: '700px',
              }}
            >
              <div style={{ position: 'relative' }}>
                <p
                  style={{
                    position: 'absolute',
                    top: '25px',
                    left: '10px',
                    fontFamily: 'TT Hoves',
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    fontSize: '14px',
                    lineHeight: '16px',
                  }}
                >
                  Scheduler Name
                </p>
                <Input
                  style={{
                    position: 'absolute',
                    top: '50px',
                    left: '0px',
                    width: '580px',
                  }}
                  placeholder={editPlaybookObject['name'] ?? 'Name'}
                  value={editPlaybookObject['name']}
                  onChange={(e) => handleEditChange(e, 'name')}
                ></Input>
              </div>
              <div style={{ position: 'relative' }}>
                <p style={{ position: 'absolute', top: '105px', left: '10px' }}>
                  Select Product
                </p>
                <Select
                  mode="multiple"
                  value={editPlaybookObject?.integration?.uuid}
                  placeholder="Select"
                  style={{
                    position: 'absolute',
                    top: '130px',
                    left: '0px',
                    width: '200px',
                  }}
                  options={splunkSettings.map((item) => ({
                    value: item.uuid,
                    label: item.name,
                  }))}
                  onChange={handleSelectedIntegrationEditChange}
                ></Select>
              </div>
              <div style={{ position: 'relative' }}>
                <p
                  style={{ position: 'absolute', top: '105px', left: '350px' }}
                >
                  Import Filter Profiles
                </p>
                <Select
                  disabled={true}
                  value={
                    (typeof selectedEditFilterProfile === 'string' &&
                      selectedEditFilterProfile) ||
                    (selectedEditFilterProfile &&
                      selectedEditFilterProfile.uuid)
                  }
                  style={{
                    position: 'absolute',
                    top: '130px',
                    left: '350px',
                    width: '150px',
                  }}
                  options={userFilterProfiles?.map((item) => ({
                    value: item.uuid,
                    label: item.name,
                  }))}
                  onChange={handleSelectedFilterProfileEditChange}
                ></Select>
              </div>
              <div style={{ position: 'relative' }}>
                <p
                  style={{
                    position: 'absolute',
                    top: '200px',
                    left: '0px',
                    fontWeight: 600,
                  }}
                >
                  Schedule a Sync
                </p>

                <p style={{ position: 'absolute', top: '240px', left: '0px' }}>
                  Recurring
                </p>
                <Switch
                  checked={allowRecurring}
                  style={{ position: 'absolute', top: '240px', left: '70px' }}
                  onChange={() => handleRecurringChange()}
                />
                <p
                  style={{ position: 'absolute', top: '240px', left: '350px' }}
                >
                  Once
                </p>
                <Switch
                  checked={allowOnce}
                  style={{ position: 'absolute', top: '240px', left: '390px' }}
                  onChange={() => handleOnceChange()}
                />
                <p
                  style={{
                    position: 'absolute',
                    top: '285px',
                    left: '10px',
                    width: '150px',
                  }}
                >
                  Rate
                </p>

                <Select
                  defaultValue={selectedRate}
                  disabled={!allowRecurring}
                  placeholder="Select"
                  style={{
                    position: 'absolute',
                    top: '310px',
                    left: '0px',
                    width: '150px',
                  }}
                  onChange={handleSelectedRateChange}
                >
                  <Select.Option value="daily">Daily</Select.Option>
                  <Select.Option value="hourly">Hourly</Select.Option>
                </Select>
                {allowRecurring && selectTimeDropdown()}

                <p
                  style={{
                    position: 'absolute',
                    top: '285px',
                    left: '360px',
                    width: '100px',
                  }}
                >
                  Date
                </p>
                <DatePicker
                  value={moment(selectedOnceDate)}
                  showTime
                  format="YYYY-MM-DD HH:mm"
                  disabled={!allowOnce}
                  style={{
                    position: 'absolute',
                    top: '310px',
                    left: '350px',
                    width: '150px',
                  }}
                  className="sidebar_input"
                  //value={selectedDay}
                  onChange={(dateM) => handleDateChange(dateM.toISOString())}
                  getPopupContainer={(trigger) => trigger.parentNode}
                />
              </div>
              <div style={{ position: 'relative' }}>
                <p
                  style={{
                    position: 'absolute',
                    top: '440px',
                    left: '0px',
                    fontWeight: 600,
                  }}
                >
                  Alerts
                </p>
                <p
                  style={{ position: 'absolute', top: '440px', left: '380px' }}
                >
                  Chat
                </p>
                <p
                  style={{ position: 'absolute', top: '440px', left: '450px' }}
                >
                  In App
                </p>
                <p
                  style={{ position: 'absolute', top: '440px', left: '520px' }}
                >
                  E-mail
                </p>
                {/*<p style={{ position: 'absolute', top: '480px', left: '0px' }}>
                  All
                </p>
                <Checkbox
                  onChange={(e) => handleAlertChange(e, 'all_app')}
                  style={{ position: 'absolute', top: '480px', left: '450px' }}
                ></Checkbox>
                <Checkbox
                  onChange={(e) => handleAlertChange(e, 'all_email')}
                  style={{ position: 'absolute', top: '480px', left: '520px' }}
                ></Checkbox>*/}
                <p style={{ position: 'absolute', top: '520px', left: '0px' }}>
                  List has been updated
                </p>
                <Checkbox
                  checked={selectedAlerts?.slack_list_updated}
                  onChange={(e) => handleAlertChange(e, 'slack_list_updated')}
                  style={{ position: 'absolute', top: '520px', left: '380px' }}
                ></Checkbox>
                <Checkbox
                  checked={selectedAlerts?.app_list_updated}
                  onChange={(e) => handleAlertChange(e, 'app_list_updated')}
                  style={{ position: 'absolute', top: '520px', left: '450px' }}
                ></Checkbox>
                <Checkbox
                  checked={selectedAlerts?.email_list_updated}
                  onChange={(e) => handleAlertChange(e, 'email_list_updated')}
                  style={{ position: 'absolute', top: '520px', left: '520px' }}
                ></Checkbox>
                <p style={{ position: 'absolute', top: '560px', left: '0px' }}>
                  Successful upload to product
                </p>
                <Checkbox
                  checked={selectedAlerts?.slack_successful_upload}
                  onChange={(e) =>
                    handleAlertChange(e, 'slack_successful_upload')
                  }
                  style={{ position: 'absolute', top: '560px', left: '380px' }}
                ></Checkbox>
                <Checkbox
                  checked={selectedAlerts?.app_successful_upload}
                  onChange={(e) =>
                    handleAlertChange(e, 'app_successful_upload')
                  }
                  style={{ position: 'absolute', top: '560px', left: '450px' }}
                ></Checkbox>
                <Checkbox
                  checked={selectedAlerts?.email_successful_upload}
                  onChange={(e) =>
                    handleAlertChange(e, 'email_successful_upload')
                  }
                  style={{ position: 'absolute', top: '560px', left: '520px' }}
                ></Checkbox>
                <p style={{ position: 'absolute', top: '600px', left: '0px' }}>
                  Unsuccessful upload to product
                </p>
                <Checkbox
                  checked={selectedAlerts?.slack_unsuccessful_upload}
                  onChange={(e) =>
                    handleAlertChange(e, 'slack_unsuccessful_upload')
                  }
                  style={{ position: 'absolute', top: '600px', left: '380px' }}
                ></Checkbox>
                <Checkbox
                  checked={selectedAlerts?.app_unsuccessful_upload}
                  onChange={(e) =>
                    handleAlertChange(e, 'app_unsuccessful_upload')
                  }
                  style={{ position: 'absolute', top: '600px', left: '450px' }}
                ></Checkbox>
                <Checkbox
                  checked={selectedAlerts?.email_unsuccessful_upload}
                  onChange={(e) =>
                    handleAlertChange(e, 'email_unsuccessful_upload')
                  }
                  style={{ position: 'absolute', top: '600px', left: '520px' }}
                ></Checkbox>
                <p style={{ position: 'absolute', top: '640px', left: '0px' }}>
                  Settings have been changed
                </p>
                <Checkbox
                  checked={selectedAlerts?.slack_settings_changed}
                  onChange={(e) =>
                    handleAlertChange(e, 'slack_settings_changed')
                  }
                  style={{ position: 'absolute', top: '640px', left: '380px' }}
                ></Checkbox>
                <Checkbox
                  checked={selectedAlerts?.app_settings_changed}
                  onChange={(e) => handleAlertChange(e, 'app_settings_changed')}
                  style={{ position: 'absolute', top: '640px', left: '450px' }}
                ></Checkbox>
                <Checkbox
                  checked={selectedAlerts?.email_settings_changed}
                  onChange={(e) =>
                    handleAlertChange(e, 'email_settings_changed')
                  }
                  style={{ position: 'absolute', top: '640px', left: '520px' }}
                ></Checkbox>
                <p style={{ position: 'absolute', top: '680px', left: '0px' }}>
                  Assigned filter profile has been changed
                </p>
                <Checkbox
                  checked={selectedAlerts?.slack_profile_changed}
                  onChange={(e) =>
                    handleAlertChange(e, 'slack_profile_changed')
                  }
                  style={{ position: 'absolute', top: '680px', left: '380px' }}
                ></Checkbox>
                <Checkbox
                  checked={selectedAlerts?.app_profile_changed}
                  onChange={(e) => handleAlertChange(e, 'app_profile_changed')}
                  style={{ position: 'absolute', top: '680px', left: '450px' }}
                ></Checkbox>
                <Checkbox
                  checked={selectedAlerts?.email_profile_changed}
                  onChange={(e) =>
                    handleAlertChange(e, 'email_profile_changed')
                  }
                  style={{ position: 'absolute', top: '680px', left: '520px' }}
                ></Checkbox>
              </div>
            </div>
          </Modal>

          <Button
            type="primary"
            //htmlType="submit"
            //style={{ position: 'absolute', right: '0px', zIndex: 1 }}
            onClick={handleNewPlaybookClick}
            //className="tab_save"
            className={styles.add_new_playbook_button}
            //type="primary"
          >
            + Add New Scheduler
          </Button>

          <Tabs defaultActiveKey="1" type="card">
            <Tabs.TabPane tab="Scheduler" key="1">
              {renderPlayBookList()}
            </Tabs.TabPane>
            <Tabs.TabPane tab="Scheduler logs" key="2">
              {renderPlayBookLogs()}
            </Tabs.TabPane>
          </Tabs>
        </>
      )}
    </div>
  );
}

export default Playbooks;
